import React from 'react'
import { string } from 'prop-types'

class LocationReviewRichSnippets extends React.Component {

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'airportParkingReviewsPages'
      case 'HCP':
        return 'airportHotelsReviewsPages'
      case 'HO':
        return 'airportHotelsReviewsPages'
      case 'LO':
        return 'airportLoungesReviewsPages'
    }

    return ''
  }

  getProductName () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'Parking'
      case 'HCP':
        return 'Hotels'
      case 'HO':
        return 'Hotels'
      case 'LO':
        return 'Lounges'
    }

    return ''
  }

  getDataFromFeed () {
    try {
      const reviewsPageData = require('../../../../../config/exports/buildTimeOnly/reviews/'+ this.getFeedPath() +'.json')
      return this.getItems(reviewsPageData)
    } catch (e) {
      return false
    }
  }

  getItems (reviewsPage) {
    const { id } = this.props
    if (!reviewsPage) return null
    let options = []
    Object.keys(reviewsPage).map(key => {
      const item = reviewsPage[key]
      if (!item || item == 'airport-parking-reviews') return null
      const itemName = item.charAt(0).toUpperCase() + item.slice(1).replace(/-/g, ' ')
      let option = (<option key={id + key} value={`/${item}.html`}>{itemName}</option>)
      options.push(option)
    })
    return options
  }

  render () {
    const items = this.getDataFromFeed()
    return (
      <div id='locationReviews' className='directionsDropdown block-sm clearfix' data-track-name='locReviewsLinkDropdown' data-track-value='click'>
        <span className="reviewsdropdown">Select a location to read all the reviews it has received : </span>
        <select>
          <option>- Airport { this.getProductName() } Reviews -</option>
          {items}
        </select>
      </div>
    )
  }
}

LocationReviewRichSnippets.propTypes = {
  id: string.isRequired
}

export default LocationReviewRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/locationReviewsDropDown.jsx